"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countVisibleCharacters = exports.trimDirectMessageText = exports.EMAIL_MESSAGE_MAX_LENGTH = exports.EMAIL_MESSAGE_MIN_LENGTH = exports.EMAIL_SUBJECT_MAX_LENGTH = void 0;
exports.EMAIL_SUBJECT_MAX_LENGTH = 200;
exports.EMAIL_MESSAGE_MIN_LENGTH = 10;
exports.EMAIL_MESSAGE_MAX_LENGTH = 3000;
const INVISIBLE = '\\u00AD\\u180E\\u200B-\\u200F\\u202A-\\u202E\\u2060-\\u2064\\u2066-\\u206F';
const EDGE_BLANKS = new RegExp(`^[\\s${INVISIBLE}]+|[\\s${INVISIBLE}]+$`, 'g');
const INVISIBLES = new RegExp(`[${INVISIBLE}]`, 'g');
const trimDirectMessageText = (text) => text.replace(EDGE_BLANKS, '');
exports.trimDirectMessageText = trimDirectMessageText;
const countVisibleCharacters = (text) => text.replace(INVISIBLES, '').length;
exports.countVisibleCharacters = countVisibleCharacters;
